import { Table } from "antd";
import "antd/dist/antd.min.css";
import "./InterfaceTable.css";

const InterfaceTable = (props) => {
  return (
    <div className="table-responsive-wrapper">
      <Table
        rowKey={(record) => props.data.indexOf(record)}
        bordered
        columns={props.columns}
        expandable={props.expandable}
        dataSource={props.data}
        pagination={{
          position: ['bottomCenter'],
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          ...props.pagination
        }}
        onChange={props.onChange}
        onRow={props.onRow}
        loading={props.loading}
        className="interface-table"
        scroll={{ x: true }}
        size="middle"
      />
    </div>
  );
};

export default InterfaceTable;